import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import WalletBox from "../partials/WalletBox";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { addDepositCash } from "../../actions/contestActions";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {} from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";
import $ from "jquery";
import classnames from "classnames";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SidebarWallet from "./SidebarWallet";
import Moment from "moment";
import * as myConstList from "../../BaseUrl";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Card from "react-bootstrap/Card";
import { loadStripe } from "@stripe/stripe-js";
import Loading from "../layout/Loading";
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const baseUrl = myConstList.baseUrl;
const publicStripeKey = myConstList.stripePublicKey;
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
  errors: {},
};
class AddCash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      winningamount: "",
      isRedeemModal: false,
      attachment: "",
      transactionId: "",
      amount: "",
      logo: "",
      cashWalletBalance: 0,
      cashWinningBalance: 0,
      errors: {},
      errorAttachment: "",
      errorTransactionId: "",
      errorAmount: "",
      urltemp: "",
      disabledButton: false,
      stripePayment: false,
      loadingProcess: false,
      themeSet: "",
      withdrawalFromDtail: {},
      transfrableAmount: 0,
      totalDeposit: 0,
      poolContributionTotal: 0,
      totalWinningAmount: 0,
      totalWithdrawnAmount: 0,
      totalTdsDeduct: 0,
      tdsDeductlist: [],
      widhdrawalFundsRecords: [],
    };

    function isJSONString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    }
    this.columns = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {Moment(record.date).format("MMMM DD YYYY h:mm:ss a")}
            </Fragment>
          );
        },
      },
      {
        key: "txStatus",
        text: "Transaction Type",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>Deposit Request</Fragment>;
        },
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>₹ {record.amount}</Fragment>;
        },
      },
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },
    ];

    this.columns2 = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {Moment(record.date).format("MMMM DD YYYY h:mm:ss a")}
            </Fragment>
          );
        },
      },
      {
        key: "contestName",
        text: "Contest Name",
        className: "upcase",
        align: "left",
        sortable: true,
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>₹ {Number(record.amount).toFixed(2)}</Fragment>;
        },
      },
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },

      // {
      //   key: "transType",
      //   text: "Entry Fee From",
      //   className: "upcase",
      //   align: "left",
      //   sortable: true,
      //   cell: record => {
      //     if(record.txStatus =='cash-wallet'){
      //       return (
      //         <Fragment>
      //           Cash Wallet
      //         </Fragment>
      //       );
      //     }else{
      //       return (
      //         <Fragment>
      //           Winning Wallet
      //         </Fragment>
      //       );
      //     }

      //   }
      // },
      // {
      //   key: "transType",
      //   text: "Transaction Type",
      //   className: "upcase",
      //   align: "left",
      //   sortable: true
      // },
      // {
      //   key: "status",
      //   text: "Status",
      //   className: "upcase",
      //   align: "left",
      //   sortable: true,

      // },
      // {
      //   key: "txStatus",
      //   text: "Regard To",
      //   className: "upcase",
      //   align: "left",
      //   sortable: true,
      //   cell: record => {
      //     return (
      //       <Fragment>
      //         Entry Fee
      //       </Fragment>
      //     );
      //   }
      // },
    ];
    this.columns3 = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {Moment(record.date).format("MMMM DD YYYY h:mm:ss a")}
            </Fragment>
          );
        },
      },
      {
        key: "contestName",
        text: "Contest Name",
        className: "upcase",
        align: "left",
        sortable: true,
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>₹ {Number(record.amount).toFixed(2)}</Fragment>;
        },
      },
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },
    ];
    this.columns4 = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {Moment(record.date).format("MMMM DD YYYY h:mm:ss a")}
            </Fragment>
          );
        },
      },
      {
        key: "",
        text: "Particulars",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          if (
            record &&
            record.withdrawalFrom &&
            record.withdrawalFrom !== "" &&
            typeof record.withdrawalFrom === "string"
          ) {
            if (isJSONString(record.withdrawalFrom)) {
              // const jsonString = JSON.stringify(record.withdrawalFrom);
              var withdrawalFrom1 = JSON.parse(record.withdrawalFrom); //{"CashWallet": 100, "WinningCashWallet": 0, "TdsDeduct": 0};
              return (
                <Fragment>
                  Winning Wallet:
                  {Number(withdrawalFrom1.winningCashWallet).toFixed(2)}
                  <br />
                  Cash Wallet:{Number(withdrawalFrom1.cashWallet).toFixed(2)}
                  <br />
                  TSD:{Number(withdrawalFrom1.tdsDeduct).toFixed(2)}
                </Fragment>
              );
            } else {
              return <Fragment></Fragment>;
            }
          } else {
            return <Fragment></Fragment>;
          }
        },
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>₹ {record.amount}</Fragment>;
        },
      },
      {
        key: "status",
        text: "Status",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{record.status}</Fragment>;
        },
      },
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{record.tx_id}</Fragment>;
        },
      },
    ];
    this.columns5 = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {Moment(record.date).format("MMMM DD YYYY h:mm:ss a")}
            </Fragment>
          );
        },
      },
      {
        key: "",
        text: "Particulars",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>Withdrawable amount ₹ {record.initiatedAmount}</Fragment>
          );
        },
      },
      {
        key: "tdsDeduct",
        text: "TDS Deduct",
        className: "tdsDeduct",
        align: "left",
        cell: (record) => {
          if (record.withdrawalFrom && record.withdrawalFrom != "") {
            let withdrawalFrom = JSON.parse(record.withdrawalFrom);
            return <Fragment>{withdrawalFrom.tdsDeduct}</Fragment>;
          }
        },
      },
      {
        key: "status",
        text: "Status",
        className: "upcase",
        align: "left",
        sortable: true,
      },
    ];
    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Fund Request List",
      no_data_text: "No user found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
    };

    this.getData = this.getData5.bind(this);
  }
  editRecord(record) {
    this.setState({ reject: record.reject, approve: record.approve });
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextPropsnextProps===========", nextProps);
    if (
      nextProps.contestdata !== undefined &&
      nextProps.contestdata.contest !== undefined &&
      nextProps.contestdata.contest.data !== undefined &&
      nextProps.contestdata.contest.data.message !== undefined &&
      nextProps.contestdata.contest.data.success
    ) {
      this.closeModal();
      toast.success(nextProps.contestdata.contest.data.message, toastStyles);
      this.getData5();
      var urltemp = "";
      if (
        localStorage.getItem("source") !== "" &&
        localStorage.getItem("theme") !== ""
      ) {
        urltemp =
          "?source=" +
          localStorage.getItem("source") +
          "&theme=" +
          localStorage.getItem("theme");
        // console.log("urlStamp==",urltemp);
        this.setState({
          urltemp: urltemp,
          themeSet: localStorage.getItem("theme"),
        });
      }
      setTimeout(() => {
        window.location.href = "/addCash" + urltemp;
      }, 1500);
    }
  }
  componentDidMount() {
    var urltemp = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      // console.log("urlStamp==",urltemp);
      this.setState({
        urltemp: urltemp,
        themeSet: localStorage.getItem("theme"),
      });
    }
    this.getData5();
  }

  getWithdrwalAmountTotal() {
    axios
      .post(baseUrl + "api/get-withdrawal-cashwallet", {}, configToken)
      .then((res) => {
        // console.log("CashWalletResponse=",res.data.data);
        // console.log("widhdrawalFundsRecords=========",this.state.widhdrawalFundsRecords);
        // let widhdrawalFundsRecords = this.state.widhdrawalFundsRecords;
        let widhdrawalFundsRecords2 = res.data.data;
        // let total1 =0;

        // if(typeof widhdrawalFundsRecords != 'undefined' && widhdrawalFundsRecords.length>0){
        //   total1 = widhdrawalFundsRecords.reduce((amount, object) => {
        //     return amount + Number(object.amount);
        //   }, 0);
        // }

        let total2 = res.data.data.reduce((amount, object) => {   
          console.log("object=======",object);
          return (object.status=='Completed')?(amount + Number(object.amount)):(0+amount);
        }, 0);
        let total = Number(total2);
        let totalListWithdrawal = widhdrawalFundsRecords2;
        let filteredArray = widhdrawalFundsRecords2.filter((item) => {
          if (typeof item.withdrawalFrom === "string") {
            try {
              const withdrawalFromObj = JSON.parse(item.withdrawalFrom);
              return withdrawalFromObj.tdsDeduct !== 0;
            } catch (error) {
              // If JSON parsing fails, you can handle the error here if needed.
              // For example, you might want to exclude the item from the filtered array.
              console.error("Error parsing JSON:", error);
              return false;
            }
          }
        });
        let totalTdsDeduct = filteredArray.reduce((amount, object) => {
          let withdrawalFromObj = JSON.parse(object.withdrawalFrom);
          return object.status=='Completed'?amount + Number(withdrawalFromObj.tdsDeduct):(0+amount);
        }, 0);
        // console.log("totalListWithdrawaltotalListWithdrawal=",totalListWithdrawal);
        this.setState({
          widhdrawalFundsRecords: totalListWithdrawal,
          totalWithdrawnAmount: total,
          totalTdsDeduct: totalTdsDeduct.toFixed(2),
          tdsDeductlist: filteredArray,
        });
      })
      .catch();
  }
  getData5() {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/profile-data", {}, configToken)
      .then((res) => {
        // console.log("profile-data=======",res.data.data);
        this.setState({
          cashWalletBalance: res.data.data.cashWalletBalance,
          cashWinningBalance: res.data.data.winningCash,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/get-deposit-transactions", {}, configToken)
      .then((res) => {
        let total = 0;
        if (res && res.data && res.data.data.length > 0) {
          total = res.data.data.reduce((amount, object) => {
            return amount + object.amount;
          }, 0);
        }
        this.setState({ records: res.data.data, totalDeposit: total });
      })
      .catch();
    axios
      .post(baseUrl + "api/get-participate-transactions", {}, configToken)
      .then((res) => {
        // console.log("CashWalletResponse=",res.data.data);
        let total = 0;
        if (res && res.data && res.data.data && res.data.data.length) {
          total = res.data.data.reduce((amount, object) => {
            return amount + Number(object.amount);
          }, 0);
        }
        this.setState({
          cashWalletRecords: res.data.data,
          poolContributionTotal: total,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/get-winning-funds", {}, configToken)
      .then((res) => {
        let total = 0;
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          total = res.data.data.reduce((amount, object) => {
            return amount + Number(object.amount);
          }, 0);
        }
        this.setState({
          winningWalletRecords: res.data.data,
          totalWinningAmount: total,
        });
      })
      .catch();
    // axios
    // .post(baseUrl + "api/get-withdrawal-funds", {}, configToken)
    // .then(res => {
    //   let response = [];
    //   if(typeof res.data.data !== 'undefined'){
    //     response = res.data.data;
    //     console.log("widhdrawalFundsRecords===",response);
    //     this.setState({ widhdrawalFundsRecords: response});
    //     this.getWithdrwalAmountTotal();
    //   }

    //   // console.log("CashWalletResponse=",response);
    // })
    // .catch();
    this.getWithdrwalAmountTotal();
  }
  closeModal = () => {
    this.setState({
      isRedeemModal: false,
    });
  };

  stripePaymentmodal = () => {
    this.setState({ stripePayment: true });
  };

  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }

  render() {
    const { errors1, loadingProcess } = this.state;
    if (loadingProcess) {
      return <Loading themeSet={this.state.themeSet} />;
    }
    return (
      <>
        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="container container2">
          <div className=" padding_d in_page">
            <h1 className="h3 white_box">Cash Wallet</h1>
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="white_box text-center">
                  <p className="h3 mb-5 h4_re">
                    <b>
                      Wallet Balance:{" "}
                      {(
                        this.state.cashWalletBalance +
                        this.state.cashWinningBalance
                      ).toFixed(2)}
                    </b>
                  </p>
                  <div className="payment-btn d-flex">
                    <a
                      href={
                        typeof this.state.urltemp != "undefined" &&
                        this.state.urltemp != ""
                          ? "/add-cash-amount" + this.state.urltemp
                          : "/add-cash-amount"
                      }
                      className="btn btn_man m-auto pl-md-5 pr-md-5"
                    >
                      Add Funds
                    </a>
                    <a
                      href={
                        typeof this.state.urltemp != "undefined" &&
                        this.state.urltemp != ""
                          ? "/withdrawal" + this.state.urltemp
                          : "/withdrawal"
                      }
                      className="btn btn_man m-auto ml-auro pl-md-5 pr-md-5"
                    >
                      Withdrawal
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="tab-content">
                  <div className="white_box ">
                    <h4 className=" mb-3 h4_re">
                      <b>Ledger</b>
                    </h4>

                    <div id="accordion">
                      <div className="new_tab_man ">
                        <a
                          className="new_tab new_tab_bg collapsed"
                          data-toggle="collapse"
                          data-target="#DepositRequest"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          <span>Deposit Amount</span>
                          <b>₹ {this.state.totalDeposit}</b>
                          <i className="las la-plus"></i>{" "}
                        </a>
                        <div
                          className="collapse"
                          id="DepositRequest"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <p>
                            <div className="ccrool_table">
                              <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                      <div className="new_tab_man ">
                        <a
                          className="new_tab collapsed"
                          data-toggle="collapse"
                          data-target="#peff"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <span>Pool Contribution</span>
                          <b>
                            ₹{" "}
                            {Number(this.state.poolContributionTotal).toFixed(
                              2
                            )}
                          </b>
                          <i className="las la-plus"></i>
                        </a>
                        <div
                          className="collapse"
                          id="peff"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <p>
                            <div className="ccrool_table">
                              <ReactDatatable
                                config={this.config}
                                records={this.state.cashWalletRecords}
                                columns={this.columns2}
                                onPageChange={this.pageChange.bind(this)}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                      <div className="new_tab_man ">
                        <a
                          className="new_tab_bg new_tab collapsed"
                          data-toggle="collapse"
                          data-target="#wcf"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          <span>Winning Amount</span>
                          <b>
                            ₹ {Number(this.state.totalWinningAmount).toFixed(2)}
                          </b>
                          <i className="las la-plus"></i>
                        </a>
                        <div
                          className="collapse"
                          id="wcf"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <p>
                            <div className="ccrool_table">
                              <ReactDatatable
                                config={this.config}
                                records={this.state.winningWalletRecords}
                                columns={this.columns3}
                                onPageChange={this.pageChange.bind(this)}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                      <div className="new_tab_man ">
                        <a
                          className="new_tab collapsed"
                          data-toggle="collapse"
                          data-target="#fwr"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          <span>Withdrawn Amount</span>
                          <b>
                            ₹{" "}
                            {Number(this.state.totalWithdrawnAmount).toFixed(2)}
                          </b>
                          <i className="las la-plus"></i>
                        </a>

                        <div
                          className="collapse"
                          id="fwr"
                          aria-labelledby="headingFour"
                          data-parent="#accordion"
                        >
                          <p>
                            <div className="ccrool_table">
                              <ReactDatatable
                                config={this.config}
                                records={this.state.widhdrawalFundsRecords}
                                columns={this.columns4}
                                onPageChange={this.pageChange.bind(this)}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                      <div className="new_tab_man ">
                        <a
                          className="new_tab_bg new_tab collapsed"
                          data-toggle="collapse"
                          data-target="#tdsww"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          <span>TDS on Winning withdrawal</span>
                          <b>
                            ₹ {Number(this.state.totalTdsDeduct).toFixed(2)}
                          </b>
                          <i className="las la-plus"></i>
                        </a>
                        <div
                          className="collapse"
                          id="tdsww"
                          aria-labelledby="headingfive"
                          data-parent="#accordion"
                        >
                          <p>
                            <div className="ccrool_table">
                              <ReactDatatable
                                config={this.config}
                                records={this.state.tdsDeductlist}
                                columns={this.columns5}
                                onPageChange={this.pageChange.bind(this)}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

AddCash.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  addDepositCash: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  contestdata: state.contestdata,
});

export default connect(mapStateToProps, { addDepositCash })(
  withRouter(AddCash)
);
